import React, { useEffect, useState } from "react";
import { api, extractError } from "../../lib/api";
import { fmtCLP } from "../../lib/format";
import { toast } from "sonner";

async function downloadBlob(url, filename) {
  const { data } = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}

export default function PortalColaborador() {
  const [logged, setLogged] = useState(false);
  const [me, setMe] = useState(null);
  const [liqs, setLiqs] = useState([]);
  const [form, setForm] = useState({ rut: "", pin: "" });

  const loadSession = async () => {
    try {
      const { data } = await api.get("/remuneraciones/portal/me");
      setMe(data);
      setLogged(true);
      const { data: list } = await api.get("/remuneraciones/portal/liquidaciones");
      setLiqs(list);
    } catch {
      setLogged(false);
      setMe(null);
    }
  };

  useEffect(() => {
    loadSession();
  }, []);

  const login = async (e) => {
    e.preventDefault();
    try {
      await api.post("/remuneraciones/portal/login", form);
      toast.success("Bienvenido");
      loadSession();
    } catch (err) {
      toast.error(extractError(err));
    }
  };

  const logout = async () => {
    await api.post("/remuneraciones/portal/logout");
    setLogged(false);
    setMe(null);
    setLiqs([]);
  };

  if (!logged) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <form
          onSubmit={login}
          className="bg-card border border-border rounded-md p-8 w-full max-w-sm space-y-4"
        >
          <h1 className="font-display text-xl font-medium text-primary">Portal del colaborador</h1>
          <p className="text-sm text-muted-foreground">Consulte sus liquidaciones con RUT y PIN asignado por RR.HH.</p>
          <input
            required
            placeholder="RUT (12.345.678-9)"
            value={form.rut}
            onChange={(e) => setForm({ ...form, rut: e.target.value })}
            className="w-full border rounded-sm px-3 py-2 text-sm"
          />
          <input
            required
            type="password"
            placeholder="PIN"
            minLength={4}
            maxLength={8}
            value={form.pin}
            onChange={(e) => setForm({ ...form, pin: e.target.value })}
            className="w-full border rounded-sm px-3 py-2 text-sm"
          />
          <button type="submit" className="w-full bg-primary text-primary-foreground text-sm py-2 rounded-sm">
            Ingresar
          </button>
        </form>
      </div>
    );
  }

  const trab = me?.trabajador;
  const emp = me?.empresa;

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-2xl mx-auto space-y-4">
        <header className="flex justify-between items-start">
          <div>
            <h1 className="font-display text-xl font-medium">
              {trab?.nombres} {trab?.apellidos}
            </h1>
            <p className="text-sm text-muted-foreground">
              {emp?.nombre} · RUT {trab?.rut}
            </p>
          </div>
          <button type="button" onClick={logout} className="text-sm underline text-muted-foreground">
            Salir
          </button>
        </header>

        <section className="bg-card border border-border rounded-md overflow-hidden">
          <h2 className="font-medium p-4 border-b">Liquidaciones cerradas</h2>
          {liqs.length === 0 ? (
            <p className="p-6 text-sm text-center text-muted-foreground">Aún no hay liquidaciones publicadas.</p>
          ) : (
            <table className="acc-table text-sm">
              <thead>
                <tr>
                  <th>Período</th>
                  <th>Líquido</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {liqs.map((l) => (
                  <tr key={l.liquidacion_id}>
                    <td>{l.periodo}</td>
                    <td>{fmtCLP(l.liquido_a_pagar)}</td>
                    <td>
                      <button
                        type="button"
                        className="text-primary underline"
                        onClick={() =>
                          downloadBlob(
                            `/remuneraciones/portal/liquidaciones/${l.liquidacion_id}/certificado`,
                            `certificado_${l.periodo}.pdf`
                          ).catch((e) => toast.error(extractError(e)))
                        }
                      >
                        PDF
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>
      </div>
    </div>
  );
}
